var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.MStateBox,{attrs:{"loading":_setup.loading,"empty":_setup.isEmpty}},[_c('div',{staticClass:"esg-list"},_vm._l((_setup.esgList),function(item,index){return _c('div',{key:index,staticClass:"esg-wrapper"},[_c(_setup.MobEsgRating,{class:{ 'esg-item': index !== 0 },attrs:{"item":item,"isOverview":true}})],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }